import ChangePasswordForm from "./ChangePasswordForm";

export { ChangePasswordForm };
